import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, reaction, runInAction } from "mobx";
import { Agent } from "../../services/agent";
import { AppStore } from "../app-store";
import { AppAction } from "./app-action";
import { BaseModel } from "./base-model";
import { Project } from "./project";

export enum IconLocation{
	bottom = 0,
	middleRight = 1,
}

export class App extends BaseModel {
	@observable name : string;
	@observable icon : string;
	@observable url : string;
	@observable settingsUrl : string;
	@observable apiOnly: boolean;
	@observable noDemo: boolean;
	@observable iconLocation: IconLocation;
	@observable actions : AppAction[] = [];
	@observable description: string;
	@observable permissionDescription: string;
	@observable enabled: boolean;
	@observable appKey: string;
	@observable secretKey: string;
	@observable selected: boolean = false;
	@observable internal: boolean;

	@observable tokenUrl: string;
	@observable loadingActions: boolean;
	@observable externalId: string;

	constructor(data : any = {}) {
		super(data);
		this.fromJSON(data);
	}

	@computed get globalActions(){
		return this.actions.filter(a => a.projectId == null);
	}

	@computed get projectActions(){
		return this.actions.filter(a => a.projectId != null);
	}

	@action async addAction(){
		let results = await Agent.Actions.create(new AppAction({"appId": this.id}));
		return runInAction(() => {
			let act = new AppAction(results);
			this.actions.push(act);
			return act;
		});
	}

	@action async removeActions(acts: AppAction[]){
		return runInAction(async () => {
			await Promise.all(acts.map(async act => {
				await Agent.Actions.remove(act.id);
			}));
			await this.loadActions();
		});
	}

	@action async loadActions(){
		this.loadingActions = true;
		let data = await Agent.Actions.all({"appId": this.id});

		runInAction(() => {
			this.actions = data.map(d => new AppAction(d));
			this.loadingActions = false;
		});
	}

	@action async loadKeys(){
		let keys = await Agent.Apps.getKeys(this.id);
		runInAction(() => {
			this.appKey = keys.appKey;
			this.secretKey = keys.secretKey;
		});
	}


	@action fromJSON(data : any = {}){
		super.fromJSON(data);
		if (data) {
			if(data.actions){
				this.actions = data.actions.map((actData) => new AppAction(actData));
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/stores/models/app.ts